import axios from 'axios';
import { API_BASE_URL } from '../config/api';

// Use a bare axios instance — no auth header (these endpoints are public,
// and we do not want stale tokens to interfere).
const client = axios.create({ baseURL: API_BASE_URL });

export interface FacilityUseFormData {
  group_type: 'non-profit' | 'private-member' | 'private-non-member' | 'other' | null;
  group_type_other: string | null;
  group_name: string | null;
  form_filled_date: string | null;
  activity: string | null;
  responsible_party_name: string | null;
  telephone: string | null;
  email: string;
  date_of_use: string | null;
  start_time: string | null;
  end_time: string | null;
  num_people_expected: number | string | null;
  security_open: boolean;
  security_close: boolean;
  security_waived: boolean;
  insurance_required: boolean;
  spaces: Array<{ name: string; fee: string }>;
  security_open_fee: string | null;
  security_close_fee: string | null;
  total_fee: string | null;
  extras: Array<{ label: string; amount: string }>;
  signature_name: string | null;
  signature_date: string | null;
}

export interface RenterPrefill {
  email: string;
  identity: {
    group_type: string | null;
    group_type_other: string | null;
    group_name: string | null;
    activity: string | null;
    responsible_party_name: string | null;
    telephone: string | null;
  };
  lastFormData: Record<string, any> | null;
}

export interface SubmitResponse {
  pdfBase64: string;
  filename: string;
  emailAlreadyKnown: boolean;
  token: string | null;
}

export async function fetchPrefill(token: string): Promise<RenterPrefill> {
  const r = await client.get(`/facility-use/renter/${encodeURIComponent(token)}`);
  return r.data;
}

export async function submitForm(args: {
  token?: string | null;
  form: FacilityUseFormData;
}): Promise<SubmitResponse> {
  const r = await client.post('/facility-use/submit', args);
  return r.data;
}

export function downloadPdfFromBase64(base64: string, filename: string) {
  const bytes = atob(base64);
  const arr = new Uint8Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) arr[i] = bytes.charCodeAt(i);
  const blob = new Blob([arr], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
